import Axios from "../../configs/axios.config";

export const createAllowances = (data) => Axios.post(`/salary/allowance`, data).then(response => response.data.data);
export const updateAllowances = (data, id) => Axios.put(`/salary/allowance/${id}`, data);
export const getAllowancesList = (data) => Axios.get('/salary/allowance', { params: data }).then(response => response.data);
export const getAllowancesDetail = (id) => Axios.get(`/salary/allowance/${id}`).then(response => response.data.data);
export const deleteAllowances = (id) => Axios.delete(`/salary/allowance/${id}`);
 